const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Ďakujeme za registráciu",
      content:
        "Vitajte,<br/>ďakujeme za registráciu. S potešením Vám oznamujeme, že Vaša registrácia na BRIDGESTONE PLUS bola skontrolovaná a schválená.<br/>Veríme, že Vám BRIDGESTONE PLUS prinesie úspech a cenné informácie a tešíme sa na ďalšiu spoluprácu.<br/>S pozdravom,</br>Tím BRIDGESTONE PLUS",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Ďakujeme za registráciu",
      content:
        "Vitajte,<br/>ďakujeme za registráciu. S potešením Vám oznamujeme, že Vaša registrácia na BRIDGESTONE PLUS bola skontrolovaná a schválená.<br/>Veríme, že Vám BRIDGESTONE PLUS prinesie úspech a cenné informácie a tešíme sa na ďalšiu spoluprácu.<br/>S pozdravom,</br>Tím BRIDGESTONE PLUS",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
